import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '~/app/core/services';

@Injectable({
  providedIn: 'root',
})
export class ProfileApi {
  constructor(private http: HttpService) {}

  activateUser(accessToken: string): Observable<{ success: boolean }> {
    return this.http.post(
      '/auth/activate-user',
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
}
